import { render, staticRenderFns } from "./ViewAttachments.vue?vue&type=template&id=32f48c62&scoped=true"
import script from "./ViewAttachments.vue?vue&type=script&lang=js"
export * from "./ViewAttachments.vue?vue&type=script&lang=js"
import style0 from "./ViewAttachments.vue?vue&type=style&index=0&id=32f48c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f48c62",
  null
  
)

export default component.exports